import { useCallback, createElement, forwardRef, useRef } from "react";
import './index.scss';
const ColorfulButton = forwardRef(({ type = 'primary', link, submit, href, text, size = 'md', shape = 'round', icon, suffix = 'none', onClick, ...otherProps }, ref) => {
    const btnClass = [type, size, shape].filter(_ => !!_).map(_ => `${'au-button'}-${_}`).join(' ');
    const linkClass = link ? 'au-button-link' : '';
    const _otherProps = otherProps || {};
    const handleClick = useCallback((e) => {
        if (link && href) {
            window.location.href = href;
        }
        if (onClick) {
            return onClick(e);
        }
    }, [onClick]);
    const nativeBtnRef = useRef(null);
    return (createElement("button", { className: `au-button ${linkClass} ${btnClass}`, ..._otherProps, onClick: handleClick, ref: ref || nativeBtnRef, type: submit ? 'submit' : 'button' },
        suffix === 'left' && createElement("i", { className: icon || "arrow-right" }),
        shape !== 'circle' && (text || ''),
        suffix === 'right' && createElement("i", { className: icon || "arrow-right" })));
});
ColorfulButton.displayName = 'ColorfulButton';
export default ColorfulButton;
